var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAccountInfo, signAmino, signDirect, DEFAULT_SNAP_ID } from './snap.js';
import Long from 'long';
export class CosmJSOfflineSigner {
    constructor(chainId, snapId) {
        this.chainId = chainId;
        if (!snapId) {
            this.snapId = DEFAULT_SNAP_ID;
        }
        else {
            this.snapId = snapId;
        }
    }
    getAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            let address = yield getAccountInfo(this.chainId, this.snapId);
            return [
                {
                    algo: "secp256k1",
                    address: address.address,
                    pubkey: new Uint8Array(Object.values(address.pubkey)),
                },
            ];
        });
    }
    signDirect(signerAddress, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.chainId !== signDoc.chainId) {
                throw new Error('Chain IDs do not match.');
            }
            const accounts = yield this.getAccounts();
            let account = accounts[0];
            if (account.address !== signerAddress) {
                throw new Error('Signer address and wallet address do not match.');
            }
            let signRes = yield signDirect(this.chainId, signerAddress, signDoc, this.snapId);
            const { accountNumber } = signDoc;
            const accountNumberLong = new Long((accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.low) || 0, accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.high, accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.unsigned);
            const sign = {
                signature: signRes.signature,
                signed: Object.assign(Object.assign({}, signRes.signed), { accountNumber: `${accountNumberLong.toString()}`, authInfoBytes: new Uint8Array(Object.values(signRes.signed.authInfoBytes)), bodyBytes: new Uint8Array(Object.values(signRes.signed.bodyBytes)) }),
            };
            return sign;
        });
    }
    // This has been added as a placeholder.
    signAmino(signerAddress, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.chainId !== signDoc.chain_id) {
                throw new Error('Chain IDs do not match');
            }
            const accounts = yield this.getAccounts();
            let account = accounts[0];
            if (account.address !== signerAddress) {
                throw new Error('Signer address and wallet address do not match.');
            }
            let signRes = yield signAmino(this.chainId, account.address, signDoc, this.snapId);
            return signRes;
        });
    }
}
//# sourceMappingURL=signer.js.map